import { useTranslation } from "react-i18next";
import React from "react";
import {
  boatTypeEnumReversed,
  levelEnumReversed,
  translationConstants,
} from "../../../constants";
import { getSportIconAndHeading } from "../../../system";
import { useSelector } from "react-redux";

const ShowUserLevels = ({
  userLevels,
  showIcon = false,
  headingClass = "font-14 fw-bold",
  listItemClass = "font-12",
  columnClasses = "col-12 col-sm-6 col-md-4 col-lg-3 mb-3",
}) => {
  const { t } = useTranslation();

  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });

  const renderSportLevels = () => {
    if (!userLevels?.length) return null;

    // Group user levels by sport ID
    return Object.entries(
      userLevels.reduce((acc, curr) => {
        if (!acc[curr.sportId]) {
          acc[curr.sportId] = [];
        }
        acc[curr.sportId].push(curr);
        return acc;
      }, {})
    ).map(([sportId, sportLevels], index) => {
      const { heading, icon } = getSportIconAndHeading(t, sportId);

      return (
        <React.Fragment key={index}>
          <div className={columnClasses}>
            <div className="d-flex align-items-start">
              {showIcon && icon && (
                <img
                  src={icon}
                  alt="sportIcon"
                  className={`${direction === "rtl" ? "ms-2" : "me-2"}`}
                />
              )}
              <div>
                <label className={headingClass}>{heading || ""}</label>
                <ul className="ps-0">
                  {sportLevels.map((sport, idx) => (
                    <li key={idx} className={listItemClass}>
                      {`${t(
                        translationConstants[
                          boatTypeEnumReversed[sport.boatTypeId]
                        ] || ""
                      )} - ${t(
                        translationConstants[
                          levelEnumReversed[sport.levelId]
                        ] || ""
                      )}`}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    });
  };
  return <div className="row">{renderSportLevels()}</div>;
};

export default ShowUserLevels;
